import i18n from 'i18next';

// dynamic return in order to get strings in current language setting
export function getCoreSubjectStrings() {
  return {
    english: i18n.t('English', { context: 'Academic Subjects' }),
    math: i18n.t('Math', { context: 'Academic Subjects' }),
    laboratoryScience: i18n.t('Laboratory Science', {
      context: 'Academic Subjects',
    }),
    socialScience: i18n.t('Social Science', { context: 'Academic Subjects' }),
    fineArts: i18n.t('Fine Arts / Career & Technical Education', {
      context: 'Academic Subjects',
    }),
    foreignLanguage: i18n.t('Foreign Language', {
      context: 'Academic Subjects',
    }),
    electives: i18n.t('Electives', { context: 'Academic Subjects' }),
  };
}

export function getCoreSubjectStrings2() {
  return {
    english: i18n.t('English', { context: 'Academic Subjects' }),
    math: i18n.t('Math', { context: 'Academic Subjects' }),
    science: i18n.t('Science', {
      context: 'Academic Subjects',
    }),
    socialStudies: i18n.t('Social Studies', { context: 'Academic Subjects' }),
    fineArts: i18n.t('Fine Art/CTE', {
      context: 'Academic Subjects',
    }),
    foreignLanguage: i18n.t('Foreign Language', {
      context: 'Academic Subjects',
    }),
    electives: i18n.t('Electives', { context: 'Academic Subjects' }),
  };
}

// TODO: currently, these English strings are used as keys in Redux and the ECAP logic
// We should switch to use variable-name-style identifiers instead
export const coreSubjectsEn = {
  english: 'English',
  math: 'Math',
  laboratoryScience: 'Laboratory Science',
  socialScience: 'Social Science',
  fineArts: 'Fine Arts / Career & Technical Education',
  foreignLanguage: 'Foreign Language',
  electives: 'Electives',
};

// dynamic return in order to get strings in current language setting
export function getAdditionalElectiveString() {
  return i18n.t('Additional Electives', { context: 'Academic Subjects' });
}

export const additionalElectiveEn = 'Additional Electives';

// dynamic return in order to get strings in current language setting
export function getAcademicYearTitles() {
  return [
    i18n.t('Freshman', { context: 'Academic' }),
    i18n.t('Sophomore', { context: 'Academic' }),
    i18n.t('Junior', { context: 'Academic' }),
    i18n.t('Senior', { context: 'Academic' }),
  ];
}
